import { render } from "./siniestros.vue?vue&type=template&id=02c28ed7&scoped=true"
import script from "./siniestros.vue?vue&type=script&lang=js"
export * from "./siniestros.vue?vue&type=script&lang=js"

import "./siniestros.vue?vue&type=style&index=0&id=02c28ed7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c28ed7"]])

export default __exports__